module.exports = __webpack_public_path__ + "static/media/now_playing.a010d29d.svg";